import {
  Component,
  EventEmitter,
  Input,
  Output,
  Pipe,
  PipeTransform,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxFormComponent, DxRadioGroupModule, DxValidatorModule } from 'devextreme-angular';
import { LookupResType, LookupResTypeEnum } from '../../enums/lookup-expr.enum';
import { Orientation } from 'devextreme/common';
import { ValueChangedEvent } from 'devextreme/ui/radio_group';
import { OrtakService } from '../../services/ortak.service';
import { firstValueFrom } from 'rxjs';
// Dashboard Faz0 Clara: eski hâli — kullanılmayan IDE otomatik-importu (devexpress paketini boşuna çekiyordu)
// import { parse } from '@devexpress/analytics-core/analytics-criteria';
import { RadioTemplateClassPipe } from '../../pipes/radio-template-class/radio-template-class.pipe';
import { ValidatorDto } from '../../models/ortak.dtos';

@Component({
  selector: 'dk-ct-gen-radio-btn',
  standalone: true,
  imports: [CommonModule, DxRadioGroupModule, RadioTemplateClassPipe  ],
  templateUrl: './ct-gen-radio-btn.component.html',
  styleUrls: ['./ct-gen-radio-btn.component.scss'],
})
export class CtGenRadioBtnComponent {
  @Input() form: DxFormComponent;
  @Input() layout: Orientation = 'horizontal';
  @Input() value: any = null;
  @Input() dataField: string = '';
  @Input() dataType: 'string' | 'number' = 'string';
  @Input() addNullOption: boolean = false;
  @Input() mainCode = 0;
  @Input() periodCode = 0;
  @Input() readOnly: boolean = false;
  @Input() lookUpType: string;
  @Input() dataSourceFilter: any;
  @Input() usePostMethod: boolean = false;
  @Input() validationRules: any[];
  @Input() valueExpr: any = 'ozelKod';
  @Input() sortConfig: { field: string; direction: 'ASC' | 'DESC' };
  @Input() tabIndex:number;
  @Output() valueChange = new EventEmitter<any>();
  @Output() resultValidation = new EventEmitter<any>();
  

  radioItems: LookupResType[] = [];
  formChanged = false;
  isFormValid: boolean = false;
  validationRul:any[];

  isRadioBtnValid:boolean = true;

  
  private nullValue: LookupResType = {
    kod: null,
    ozelKod: null,
    aciklama: 'Boş',
  };

  constructor(private ortakService: OrtakService) {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['lookUpType'] ||
      changes['mainCode'] ||
      changes['periodCode'] ||
      changes['mainCode']
    ) {
      this.getDataSource();
    }

      if (
      (changes ||
      changes['validationRules']) 
    ) {
      this.checkValidation();
    }


  }


  async getDataSource() {
    //ana kod ve dönem kod yoksa default cache'li istek
    //cache istemiyorsanız post kullanın
    if (this.usePostMethod || this.mainCode != 0 || this.periodCode != 0) {
      await this.getLookupPostMethod();
    } else {
      this.getLookupGetMethod();
    }
  }

  onValueChanged(e: ValueChangedEvent) {
    if (this.form && this.dataField && this.dataType === 'number' && e?.value) {
      this.form.instance.updateData(this.dataField, parseInt(e.value));
    } else if (
      this.form &&
      this.dataField &&
      this.dataType === 'string' &&
      e?.value
    ) {
      this.form.instance.updateData(this.dataField, e.value);
    } else if (this.form && this.dataField && e?.value == null) {
      this.form.instance.updateData(this.dataField, null);
    }

    if (this.dataType === 'number') {
      this.valueChange.emit(parseInt(e.value));
    } else {
      this.valueChange.emit(e.value);
    }

    this.checkValidation();
  }



  getLookupGetMethod() {
    this.ortakService
      .getLookup(this.lookUpType, this.mainCode, this.periodCode, null, null)
      .subscribe((data: any) => {
        this.radioItems = data.items;
        if (this.addNullOption) {
          this.radioItems.push(this.nullValue);
        }
        if (this.dataSourceFilter) {
          this.radioItems = this.radioItems.filter(this.dataSourceFilter);
        }

        if(this.sortConfig){
          const { field, direction } = this.sortConfig;
          this.radioItems = [...data.items].sort((a, b) => {
            if (direction === 'ASC') {
              return a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
            } else {
              return a[field] > b[field] ? -1 : a[field] < b[field] ? 1 : 0;
            }
          });
        }


      });
  }

  async getLookupPostMethod() {
    const data = await firstValueFrom(
      this.ortakService.getLookupPost(
        this.lookUpType,
        this.mainCode,
        this.periodCode,
        null,
        null
      )
    );

    this.radioItems = data.items;
    if (this.addNullOption) {
      this.radioItems.push(this.nullValue);
    }
    if (this.dataSourceFilter) {
      this.radioItems = this.radioItems.filter(this.dataSourceFilter);
    }

    if(this.sortConfig){
      const { field, direction } = this.sortConfig;
      this.radioItems = [...data.items].sort((a, b) => {
        if (direction === 'ASC') {
          return a[field] < b[field] ? -1 : a[field] > b[field] ? 1 : 0;
        } else {
          return a[field] > b[field] ? -1 : a[field] < b[field] ? 1 : 0;
        }
      });
    }


  }


  checkValidation(){
    this.validationRules?.map( (validation: ValidatorDto) => {
      if(validation?.type === 'required'){
        if(this.value == null || this.value == ''){
          this.isRadioBtnValid = false;
        }else{
          this.isRadioBtnValid = true;
        }
      }
    })
  }


}
